<p-confirmDialog [transitionOptions]="'170ms'" [acceptButtonStyleClass]="'btn-dialog-danger'"
  [rejectButtonStyleClass]="'btn-dialog-default'"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header-light page-title="PROCESSOS LICITATÓRIOS" fa-icon="clipboard-list"></lib-page-header-light>
        </div>
        <div class="col-md-7">
          <button [routerLink]="['/licitacoes']" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a class="btn btn-sm btn-outline-secondary float-right ml-2" data-toggle="modal"
            data-target="#dialogLicitacoesE" *ngIf="etapaMemorial && entidade.modalidade?.codigo === 8">
            Exportar/Importar
          </a>
          <button (click)="remover()" *ngIf="entidade.id && !etapaCredenciamento"
            class="btn btn-outline-danger btn-sm float-right mr-2">
            <i class="fa fa-trash-alt"></i> Remover
          </button>
          <button data-toggle="modal" data-target="#dialogImportarProcessoAnterior" *ngIf="!entidade.id"
            class="btn btn-outline-success btn-sm float-right mr-2" title="Importar informações de processo anterior">
            <i class="fa fa-clone"></i>
          </button>
          <div class="dropdown" *ngIf="entidade.id">
            <button class="btn btn-sm btn-outline-secondary float-right dropdown-toggle mr-2" type="button"
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Relatórios
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioAtaJulgamento">
                Ata de Abertura e Julgamento
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioEstimativaPreco">
                Estimativa de Preços
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioMapaPreco">
                Mapa de Preços
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioMemorial">
                Memorial Descritivo
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioTermoHomologacao">
                Termo de Homologação
              </a>
              <hr class="dropdown-divider" *ngIf="etapaJulgamento">
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioAtaPersonalizada"
                *ngIf="etapaJulgamento && entidade.modalidade?.codigo === 7">
                Ata de Sessão Pública
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioClassificacaoFinal"
                *ngIf="etapaJulgamento">
                Classificação Final
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioLances"
                *ngIf="etapaJulgamento && entidade.modalidade?.codigo === 7">
                Quadro de Lances
              </a>
              <a class="dropdown-item" data-toggle="modal" data-target="#dialogRelatorioVencedores"
                *ngIf="etapaJulgamento">
                Vencedores
              </a>
            </div>
          </div>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>

      <hr class="mt-0 mb-2" />

      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="processo-tab" data-toggle="tab" href="#processo" role="tab"
            aria-controls="processo" aria-selected="true">Processo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="memorial-tab" data-toggle="tab" href="#memorial" role="tab" aria-controls="memorial"
            aria-selected="false">Memorial</a>
        </li>
        <li *ngIf="etapaMemorial" class="nav-item">
          <a class="nav-link" id="proponente-tab" data-toggle="tab" href="#proponente" role="tab"
            aria-controls="proponente" aria-selected="true">Proponentes</a>
        </li>
        <li *ngIf="etapaMemorial" class="nav-item">
          <a class="nav-link" id="proposta-tab" data-toggle="tab" href="#proposta" role="tab" aria-controls="proposta"
            aria-selected="true">Propostas</a>
        </li>
        <li *ngIf="etapaJulgamento" class="nav-item">
          <a class="nav-link" id="contrato-tab" data-toggle="tab" href="#contrato" role="tab" aria-controls="contrato"
            aria-selected="true">Contratos</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane fade show active" id="processo" role="tabpanel" aria-labelledby="processo-tab">
          <span class="badge badge-pill badge-info"
            *ngIf="+entidadeForm.get('valor_estimado').value > 0 && 80000 > +entidadeForm.get('valor_estimado').value">
            Licitação exclusiva para EPP/ME
          </span>
          <span class="badge badge-pill badge-warning"
            *ngIf="entidadeForm.get('modalidade').value && +entidadeForm.get('modalidade').value['valor_limite'] > 0 && +entidadeForm.get('valor_estimado').value > +entidadeForm.get('modalidade').value['valor_limite']">
            O valor estimado excede o limite da modalidade selecionada
            ({{entidadeForm.get('modalidade').value['valor_limite'] | number:'1.2-2'}}).
          </span>
          <div class="row">
            <div class="col-9">
              <div class="row">
                <div class="col-12">
                  <p-fieldset legend="Dados do Processo">
                    <div class="mt-3 row">
                      <div class="form-group form-group-sm col-md-2">
                        <label for="numero" class="required">N˚ Licitação</label>
                        <input #numero_ formControlName="numero" type="text" class="form-control" id="numero"
                          [imask]="{mask: '00000/0000'}" unmask="true" *ngIf="!entidade.id || 1 >= entidade.sequencia">
                        <span *ngIf="entidade.sequencia > 1" class="form-control">{{entidade.numero | LICITACAO}}
                          <span class="badge badge-primary">{{entidade.sequencia}}</span>
                        </span>
                      </div>
                      <div class="form-group form-group-sm col-md-4">
                        <label for="situacao" class="required">Situação</label>
                        <select [compareWith]="compareFn" formControlName="situacao" id="situacao" class="form-control">
                          <option *ngFor="let item of listaSituacoes" [value]="item.id">{{item.nome}}</option>
                        </select>
                      </div>
                      <div class="form-group form-group-sm col-md-2">
                        <label for="processo" class="required">Processo</label>
                        <input formControlName="processo" type="text" class="form-control" id="processo"
                          [imask]="{mask: [ {mask: '0000/0000'}, {mask: '00000/0000'} ]}">
                      </div>
                      <div class="form-group form-group-sm col-md-2">
                        <label for="valor_estimado" class="required">Vl. Estimado</label>
                        <input unmask="typed" [imask]="imaskConfig" formControlName="valor_estimado" type="text"
                          class="form-control text-right font-weight-bold text-primary" id="valor_estimado"
                          placeholder="0,00">
                      </div>
                      <div class="form-group form-group-sm col-md-2">
                        <label>Vl. Licitado</label>
                        <span class="form-control text-right font-weight-bold text-primary">
                          {{entidadeForm.get('valor_licitado').value | number:'1.2-2'}}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group form-group-sm col-md-6">
                        <label for="modalidade" class="required">Modalidade</label>
                        <select [compareWith]="compareFn" id="modalidade" formControlName="modalidade"
                          class="form-control" (change)="carregarContratacoes(true)">
                          <option [ngValue]="item" *ngFor="let item of listaModalidades">
                            {{item.codigo}} - {{item.nome}}
                          </option>
                        </select>
                      </div>
                      <div class="form-group form-group-sm col-md-6">
                        <label for="tipo_contratacao" class="required">Tipo de Contratação</label>
                        <select [compareWith]="compareFn" id="tipo_contratacao" formControlName="tipo_contratacao"
                          class="form-control">
                          <option [ngValue]="item" *ngFor="let item of listaTipoContratacoes">
                            {{item.nome}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group form-group-sm col-md-6">
                        <label for="setor" class="required">Setor</label>
                        <p-autoComplete id="setor" formControlName="setor" field="nome"
                          [suggestions]="setorAutoComplete.lista" (completeMethod)="setorAutoComplete.filtrar($event)"
                          inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }"
                          [forceSelection]="true" [autoHighlight]="true">
                        </p-autoComplete>
                      </div>
                      <div class="form-group form-group-sm col-md-6">
                        <label for="comissao">Comissão</label>
                        <select [compareWith]="compareFn" id="comissao" formControlName="comissao"
                          class="form-control float-left" style="width: calc(100% - 46px)"
                          (change)="preencherMembros()">
                          <option [value]="null" selected>Selecione</option>
                          <option [ngValue]="item" *ngFor="let item of listaComissoes">
                            {{item.nome}}
                          </option>
                        </select>
                        <button class="btn btn-outline-secondary float-right" style="height: calc(1.5em + 0.75rem)"
                          data-toggle="modal" data-target="#dialogComissaoParticipantes"
                          title="Visualizar participantes">
                          <i class="fa fa-user-check"></i>
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group form-group-sm col-md-3">
                        <label for="naturezaLicitacao">Natureza da Licitação</label>
                        <select [compareWith]="compareFn" id="naturezaLicitacao" class="form-control"
                          formControlName="natureza">
                          <option [value]="null" selected>Selecione</option>
                          <option *ngFor="let item of listaNatureza" [ngValue]="item.id">{{item.nome}}</option>
                        </select>
                      </div>
                      <div class="form-group form-group-sm col-md-3">
                        <label for="tipoObjeto">Tipo de Objeto</label>
                        <select [compareWith]="compareFn" id="tipoObjeto" class="form-control"
                          formControlName="tipo_objeto" (change)="carregarObjetosLicitacao()">
                          <option [value]="null" selected>Selecione</option>
                          <option *ngFor="let item of listaTipoObjeto" [ngValue]="item.id">{{item.nome}}</option>
                        </select>
                      </div>
                      <div class="form-group form-group-sm col-md-6">
                        <label for="objetoLicitacao">Objeto da Licitação</label>
                        <select [compareWith]="compareFn" id="objetoLicitacao" class="form-control"
                          formControlName="objeto_licitacao">
                          <option [value]="null" selected>Selecione</option>
                          <option *ngFor="let item of listaObjetoLicitacao" [ngValue]="item.id">{{item.nome}}</option>
                        </select>
                      </div>
                      <div class="form-group form-group-sm col-md-6">
                        <label for="tipoLicitacao">Tipo de Licitação</label>
                        <select [compareWith]="compareFn" id="tipoLicitacao" class="form-control"
                          formControlName="tipo_licitacao">
                          <option [value]="null" selected>Selecione</option>
                          <option *ngFor="let item of listaTipoLicitacao" [ngValue]="item.id">{{item.nome}}</option>
                        </select>
                      </div>
                      <div class="form-group form-group-sm col-md-6">
                        <label for="beneficioLei1232006">Benefício da LC 123/2006</label>
                        <select [compareWith]="compareFn" id="beneficioLei1232006" class="form-control"
                          formControlName="lei_1232006">
                          <option [value]="null" selected>Selecione</option>
                          <option *ngFor="let item of listaLei1232006" [ngValue]="item.id">{{item.nome}}</option>
                        </select>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p-fieldset legend="Datas e Prazos" [toggleable]="true" [collapsed]="entidade.id">
                    <div class="mt-3 row">
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="prazo_pagamento">Prazo Pagamento</label>
                        <input unmask="typed" [imask]="imaskQtd" formControlName="prazo_pagamento" type="text"
                          class="form-control text-right" id="prazo_pagamento">
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="prazo_entrega">Prazo Entrega</label>
                        <input unmask="typed" [imask]="imaskQtd" formControlName="prazo_entrega" type="text"
                          class="form-control text-right" id="prazo_entrega">
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_abertura" class="required">Abertura</label>
                        <p-calendar id="data_abertura" formControlName="data_abertura" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_inicio">Início</label>
                        <p-calendar id="data_inicio" formControlName="data_inicio" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_termino">Término</label>
                        <p-calendar id="data_termino" formControlName="data_termino" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_ata">Ata</label>
                        <p-calendar id="data_ata" formControlName="data_ata" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_edital">Edital</label>
                        <p-calendar id="data_edital" formControlName="data_edital" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_julgamento">Julgamento</label>
                        <p-calendar id="data_julgamento" formControlName="data_julgamento"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                          [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_parecer">Parecer Jurídico</label>
                        <p-calendar id="data_parecer" formControlName="data_parecer" inputStyleClass="form-control"
                          dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_publicacao">Publicação</label>
                        <p-calendar id="data_publicacao" formControlName="data_publicacao"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                          [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_homologacao">Homologação</label>
                        <p-calendar id="data_homologacao" formControlName="data_homologacao"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                          [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_cancelamento">Cancelamento</label>
                        <p-calendar id="data_cancelamento" formControlName="data_cancelamento"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                          [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_assinatura">Assinatura</label>
                        <p-calendar id="data_assinatura" formControlName="data_assinatura"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                          [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-2 col-md-3 col-sm-6">
                        <label for="data_ratificacao">Ratificação</label>
                        <p-calendar id="data_ratificacao" formControlName="data_ratificacao"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="true"
                          [showButtonBar]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-3 col-md-4 col-sm-6">
                        <label for="data_abertura_env">Abertura Envelope</label>
                        <p-calendar id="data_abertura_env" formControlName="data_abertura_env"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="false"
                          [showButtonBar]="true" showTime="true" [showIcon]="true">
                        </p-calendar>
                      </div>
                      <div class="form-group form-group-sm col-lg-3 col-md-4 col-sm-6">
                        <label for="data_entrega_env">Entrega Envelope</label>
                        <p-calendar id="data_entrega_env" formControlName="data_entrega_env"
                          inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [showOnFocus]="false"
                          [showButtonBar]="true" showTime="true" [showIcon]="true">
                        </p-calendar>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p-fieldset legend="Justificativa" [toggleable]="true" [collapsed]="entidade.id">
                    <div class="mt-3 form-group form-group-sm col-md-12">
                      <label for="justificativa" class="required">Justificativa do Processo</label>
                      <textarea formControlName="justificativa" class="form-control" id="justificativa"
                        rows="5"></textarea>
                    </div>
                  </p-fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p-fieldset legend="Objeto" [toggleable]="true" [collapsed]="entidade.id">
                    <div class="mt-3 form-group form-group-sm col-md-12">
                      <label for="objeto" class="required">Objeto do Processo</label>
                      <textarea formControlName="objeto" class="form-control" id="objeto" rows="5"></textarea>
                    </div>
                  </p-fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p-fieldset legend="Fiscais" [toggleable]="true" [collapsed]="entidade.id">
                    <div class="mt-3 col-md-12">
                      <app-licitacao-fiscal [(entidade)]="entidade" [login]="login"></app-licitacao-fiscal>
                    </div>
                  </p-fieldset>
                </div>
              </div>
            </div>
            <div class="col-3 pl-0">
              <p-fieldset legend="Outras Opções">
                <label class="mt-3">Formato de Contratação</label>
                <p-selectButton [options]="formatosLicitacao" formControlName="formato_contratacao" optionValue="id">
                  <ng-template let-formato>
                    <span class="p-1" style="font-size: 0.8rem;">{{formato.nome}}</span>
                  </ng-template>
                </p-selectButton>
                <hr />
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input formControlName="enviar_transparencia" type="checkbox" />
                    <span></span>
                    Visível no transparência
                  </label>
                </div>
              </p-fieldset>
              <p-fieldset legend="Etapas do Processo">
                <ul class="list-group list-group-flush" style="margin-left: -1rem; margin-right: -1rem;">
                  <li class="list-group-item p-1 pl-3">
                    <i [class]="(etapaProcesso ? 'fa fa-check' : 'far fa-square')"></i> Dados do Processo
                  </li>
                  <li class="list-group-item p-1 pl-3">
                    <i [class]="(etapaMemorial ? 'fa fa-check' : 'far fa-square')"></i> Memorial
                  </li>
                  <li class="list-group-item p-1 pl-3">
                    <i [class]="(etapaCredenciamento ? 'fa fa-check' : 'far fa-square')"></i> Credenciamentos
                  </li>
                  <li class="list-group-item p-1 pl-3">
                    <i [class]="(etapaProposta ? 'fa fa-check' : 'far fa-square')"></i> Propostas
                  </li>
                  <li class="list-group-item p-1 pl-3">
                    <i [class]="(etapaJulgamento ? 'fa fa-check' : 'far fa-square')"></i> Julgamento das Propostas
                  </li>
                  <li class="list-group-item p-1 pl-3">
                    <i [class]="(etapaContrato ? 'fa fa-check' : 'far fa-square')"></i> Geração de Contratos
                  </li>
                </ul>
              </p-fieldset>
              <lib-licitacao-audesp-menu *ngIf="entidade?.id" [entidade]="entidade?.licitacao_audesp">
              </lib-licitacao-audesp-menu>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="memorial" role="tabpanel" aria-labelledby="memorial-tab">
          <app-memorial [edicao]="!etapaCredenciamento" [(entidade)]="entidade" [login]="login"></app-memorial>
        </div>
        <div *ngIf="etapaMemorial" class="tab-pane fade" id="proponente" role="tabpanel"
          aria-labelledby="proponente-tab">
          <app-proponente [(entidade)]="entidade" [login]="login" [edicao]="!etapaJulgamento"></app-proponente>
        </div>
        <div *ngIf="etapaMemorial" class="tab-pane fade" id="proposta" role="tabpanel" aria-labelledby="proposta-tab">
          <app-proposta (julgamentoEvent)="julgarPropostas()" [(entidade)]="entidade" [login]="login"
            [edicao]="!etapaJulgamento" [dataAtualizacao]="entidade.data_alteracao"></app-proposta>
        </div>
        <div *ngIf="etapaJulgamento" class="tab-pane fade" id="contrato" role="tabpanel" aria-labelledby="contrato-tab">
          <app-contrato-licitacao [(entidade)]="entidade" [login]="login"></app-contrato-licitacao>
        </div>
      </div>
      <!-- <pre *ngIf="entidade">{{ entidade?.proponentes | json}}</pre> -->
    </div>
    <div class="modal fade" id="dialogComissaoParticipantes" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header text-white bg-primary">
            <h5 class="modal-title" id="title" style="font-size: 1rem;">Membros participantes neste processo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row mb-3" *ngIf="entidade.comissao">
              <div class="col-5">
                <span class="font-weight-bold">Comissão: </span>
                <span>{{entidade.comissao.nome}}</span>
              </div>
              <div class="col-3">
                <span class="font-weight-bold">Portaria / Ano: </span>
                <span>{{entidade.comissao.portaria}}/{{entidade.comissao.ano_portaria}}</span>
              </div>
              <div class="col-4">
                <span class="font-weight-bold">Tipo de Comissão: </span>
                <span>{{entidade.comissao.tipo}}</span>
              </div>
            </div>
            <table class="table table-sm table-eddy">
              <thead>
                <tr>
                  <th style="width: 50px" scope="col"></th>
                  <th scope="col">Membro</th>
                  <th style="width: 155px" scope="col">Atribuição</th>
                  <th style="width: 175px" scope="col">Natureza Cargo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of entidade.comissao_membros">
                  <td>
                    <div class="checkbox checbox-switch switch-primary">
                      <label>
                        <input [(ngModel)]="item.marcado" [ngModelOptions]="{standalone: true}" type="checkbox" />
                        <span></span>
                      </label>
                    </div>
                  </td>
                  <td>
                    {{item.comissao_membro?.pessoa?.cpf_cnpj | CPF}} {{item.comissao_membro?.pessoa?.nome}}
                  </td>
                  <td>{{item.comissao_membro?.atribuicao}}</td>
                  <td>{{item.comissao_membro?.natureza_cargo}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link btn-sm text-muted" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="dialogImportarProcessoAnterior" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header text-white bg-success">
            <h5 class="modal-title" id="title" style="font-size: 1rem;">Importar dados de processo anterior</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p-autoComplete formControlName="processo_cc" [field]="licitacaoAutoComplete.conversor"
                  (onSelect)="licitacaoAutoComplete.atualizar(false)" [suggestions]="licitacaoAutoComplete.lista"
                  (completeMethod)="licitacaoAutoComplete.filtrar($event)" inputStyleClass="form-control" minLength="3"
                  [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                  *ngIf="licitacaoAutoComplete">
                  <ng-template let-licitacao pTemplate="item">
                    {{licitacao.numero | LICITACAO}} - {{licitacao.modalidade?.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
            <div class="row mt-3 text-muted" *ngIf="entidadeForm.get('processo_cc')?.value">
              <div class="col-6">
                <label class="font-weight-bold">Nº Licitação:</label>
                <label class="ml-2">
                  {{entidadeForm.get('processo_cc')?.value?.numero | LICITACAO}}
                </label>
              </div>
              <div class="col-6">
                <label class="font-weight-bold">Nº Processo:</label>
                <label class="ml-2">
                  {{entidadeForm.get('processo_cc')?.value?.processo | LICITACAO}}
                </label>
              </div>
              <div class="col-12">
                <label class="font-weight-bold">Modalidade:</label>
                <label class="ml-2">
                  {{entidadeForm.get('processo_cc')?.value?.modalidade?.nome}}
                </label>
              </div>
            </div>
            <hr />
            <div class="row" *ngIf="licitacaoImportOpt">
              <div class="col-6">
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input [(ngModel)]="licitacaoImportOpt.processo" [ngModelOptions]="{standalone: true}"
                      type="checkbox" />
                    <span></span>
                    Dados do processo
                  </label>
                </div>
              </div>
              <!-- <div class="col-6">
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input [(ngModel)]="licitacaoImportOpt.datas" [ngModelOptions]="{standalone: true}"
                      type="checkbox" />
                    <span></span>
                    Datas e Prazos
                  </label>
                </div>
              </div> -->
              <div class="col-6">
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input [(ngModel)]="licitacaoImportOpt.justificativa" [ngModelOptions]="{standalone: true}"
                      type="checkbox" />
                    <span></span>
                    Justificativa
                  </label>
                </div>
              </div>
              <div class="col-6">
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input [(ngModel)]="licitacaoImportOpt.objeto" [ngModelOptions]="{standalone: true}"
                      type="checkbox" />
                    <span></span>
                    Objeto
                  </label>
                </div>
              </div>
              <div class="col-6">
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input [(ngModel)]="licitacaoImportOpt.fiscais" [ngModelOptions]="{standalone: true}"
                      type="checkbox" />
                    <span></span>
                    Fiscais ({{licitacaoImportOpt.licitacao?.fiscais?.length}})
                  </label>
                </div>
              </div>
              <div class="col-6">
                <div class="checkbox checbox-switch switch-success">
                  <label>
                    <input [(ngModel)]="licitacaoImportOpt.memorial" [ngModelOptions]="{standalone: true}"
                      type="checkbox" />
                    <span></span>
                    Itens do Memorial ({{licitacaoImportOpt.licitacao?.itens?.length}})
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link btn-sm text-muted" data-dismiss="modal">Fechar</button>
            <button (click)="importarProcessoAnterior()" class="btn btn-sm btn-success">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<app-ata-julgamento-rpt [licitacao]="entidade"></app-ata-julgamento-rpt>
<app-ata-personalizada-rpt [licitacao]="entidade"></app-ata-personalizada-rpt>
<app-classificacao-rpt [licitacao]="entidade"></app-classificacao-rpt>
<app-estimativa-preco-rpt [licitacao]="entidade"></app-estimativa-preco-rpt>
<app-lances-rpt [licitacao]="entidade"></app-lances-rpt>
<app-mapa-preco-rpt [licitacao]="entidade"></app-mapa-preco-rpt>
<app-memorial-rpt [licitacao]="entidade"></app-memorial-rpt>
<app-termo-homologacao-rpt [licitacao]="entidade"></app-termo-homologacao-rpt>
<app-vencedores-rpt [licitacao]="entidade"></app-vencedores-rpt>
<lib-bb-licitacoes-e [entidade]="entidade"></lib-bb-licitacoes-e>